(function () {
  'use strict';
  if (window.InnermonOfficeResultImage) return;

  // A post-round export only. No gameplay render loop, storage, upload or service.
  const WIDTH = 1080;
  const HEIGHT = 1792;
  const TIMEOUT_MS = 7000;
  // Offline-generated QR Model 2, error correction M; no remote QR service or runtime library.
  // Reproduce/independently decode in reviews/office-break-result-qr-20261012.
  const PLAY_QR = {
    public: [
      '111111101000111010110101001111111','100000101100010011000111001000001','101110100011000110111011001011101',
      '101110101001101111010010101011101','101110100110001000010100101011101','100000100111111001111000001000001',
      '111111101010101010101010101111111','000000001110000001100010100000000','101101110100101001110100101001011',
      '001010010110101011011001001101111','110100100110101010000001100111011','011010011111111100101000100101000',
      '110001101011000000110010110111001','011100001100100011010100100100010','110010100100001110010100101000100',
      '010110010000000010110111011001100','000010100100000100101110011011100','010000011111001111001011111011011',
      '110100101101010111001000110110110','111101000010111100011010111010000','000010110011010000111101000101100',
      '110001010101001100111001011000101','000111101101111011001111100110011','011111000000101010100010100101011',
      '100001110010011111000011111110010','000000001000010111010011100011010','111111101001111000010001101010000',
      '100000101101001110011111100011101','101110100111110001011101111110101','101110101001010000101010100101101',
      '101110101100010001001001001100100','100000100010100111100010111111001','111111101011001111100110001011100'
    ],
    development: [
      '1111111010010000000101010110101111111','1000001011010101001011111100101000001','1011101000111100000100001100001011101',
      '1011101011011111110010111111001011101','1011101001111111110100001001101011101','1000001000001111100110001010001000001',
      '1111111010101010101010101010101111111','0000000011110001111010110011100000000','1011011100100001110010000011101001011',
      '1100010001110111000101110000100100010','1001111101001110110000111110011000100','0110010111110011101100001111110101100',
      '1001001010110101110100101101011011111','0111110000100111010101101111111111011','1010001101110010000101000100010010110',
      '1111000100011000101111101011111110000','1011001011010100100001110101100101100','1011010000011011111000111001001000011',
      '1000001100000001000000001111010010011','1110110000001101010010110010011011010','0100111011110010010011111010110110001',
      '1111010110100100100110010000100001000','0011011000100100111010011000010100000','0010110010011100000000011111110011111',
      '0001001101001111111010111111111010110','0101000011001101001111001001111110011','0100001010100010111111000000111001010',
      '1011010111010101100001100010100110001','0001011101111000001001110100111110100','0000000011010011001010010101100010101',
      '1111111011111111110011100110101010111','1000001011010010011000011001100010000','1011101001111111010111111110111111011',
      '1011101010011000000101110110011010011','1011101010100000101001011101011011000','1000001000101111000110011110001110100',
      '1111111010001011010110111111010011111'
    ]
  };
  function drawPlayQR(ctx, developmentPreview) {
    const rows = PLAY_QR[developmentPreview ? 'development' : 'public'];
    if (!rows || rows.some((row) => row.length !== rows.length || /[^01]/.test(row))) throw new Error('Game QR unavailable');
    // Four-module quiet zone on every side, integer pixels, opaque white and black.
    const cell = Math.floor(360 / (rows.length + 8));
    const side = (rows.length + 8) * cell;
    const x = 90 + Math.floor((360 - side) / 2), y = 1340 + Math.floor((360 - side) / 2);
    ctx.fillStyle = '#fff'; ctx.fillRect(x, y, side, side);
    ctx.fillStyle = '#000';
    rows.forEach((row, r) => { for (let c = 0; c < row.length; c += 1) if (row[c] === '1') ctx.fillRect(x + (c + 4) * cell, y + (r + 4) * cell, cell, cell); });
  }
  function loadImage(src, signal) {
    return new Promise((resolve, reject) => {
      const image = new Image();
      let settled = false;
      const finish = (error) => {
        if (settled) return;
        settled = true;
        window.clearTimeout(timeout);
        signal.removeEventListener('abort', abort);
        image.onload = image.onerror = null;
        if (error) { image.src = ''; reject(error); } else resolve(image);
      };
      const abort = () => finish(new Error('Result export cancelled'));
      const timeout = window.setTimeout(() => finish(new Error('Result artwork timed out')), TIMEOUT_MS);
      image.onload = () => finish(image.naturalWidth ? null : new Error('Empty result artwork'));
      image.onerror = () => finish(new Error('Result artwork unavailable'));
      // Must precede src: the ordinary actor canvases are never used for export.
      image.crossOrigin = 'anonymous';
      signal.addEventListener('abort', abort, { once: true });
      if (signal.aborted) { abort(); return; }
      image.src = src;
    });
  }
  function bounded(promise, ms, label) {
    let timer;
    return Promise.race([promise, new Promise((_, reject) => { timer = window.setTimeout(() => reject(new Error(label)), ms); })])
      .finally(() => window.clearTimeout(timer));
  }
  function contain(ctx, image, x, y, width, height) {
    const scale = Math.min(width / image.naturalWidth, height / image.naturalHeight);
    const w = image.naturalWidth * scale;
    const h = image.naturalHeight * scale;
    ctx.drawImage(image, x + (width - w) / 2, y + (height - h) / 2, w, h);
  }
  function wrapped(ctx, text, x, y, maxWidth, lineHeight) {
    let line = '';
    for (const word of text.split(' ')) {
      const candidate = line ? line + ' ' + word : word;
      if (line && ctx.measureText(candidate).width > maxWidth) {
        ctx.fillText(line, x, y); y += lineHeight; line = word;
      } else line = candidate;
    }
    ctx.fillText(line, x, y);
  }
  function draw(snapshot, logo, specimen, developmentPreview) {
    const canvas = document.createElement('canvas');
    canvas.width = WIDTH; canvas.height = HEIGHT;
    const ctx = canvas.getContext('2d');
    if (!ctx) throw new Error('Result canvas unavailable');
    ctx.fillStyle = '#f4f1e8'; ctx.fillRect(0, 0, WIDTH, HEIGHT);
    ctx.strokeStyle = '#171714'; ctx.lineWidth = 3; ctx.strokeRect(32, 32, WIDTH - 64, HEIGHT - 64);
    ctx.fillStyle = '#fff'; ctx.fillRect(70, 60, 940, 156);
    ctx.save(); ctx.filter = 'invert(1)'; contain(ctx, logo, 235, 68, 610, 140); ctx.restore();
    ctx.fillStyle = '#171714'; ctx.textAlign = 'center';
    ctx.font = '700 26px "Space Grotesk", Arial, sans-serif';
    ctx.fillText('OFFICE BREAK / RESULT ON FILE', WIDTH / 2, 260);
    ctx.fillStyle = '#fff'; ctx.fillRect(70, 292, 940, 535);
    if (specimen) contain(ctx, specimen, 240, 302, 600, 515);
    else {
      ctx.fillStyle = '#171714'; ctx.font = '500 50px "Space Grotesk", Arial, sans-serif';
      ctx.fillText('No targets contained.', WIDTH / 2, 540);
      ctx.font = '400 30px "DM Sans", Arial, sans-serif';
      ctx.fillText('The office remains under observation.', WIDTH / 2, 592);
    }
    ctx.fillStyle = '#57554e'; ctx.font = '700 24px "Space Grotesk", Arial, sans-serif';
    ctx.fillText(snapshot.species ? 'MOST CONTAINED' : 'BREAK COMPLETE', WIDTH / 2, 874);
    ctx.fillStyle = '#171714'; ctx.font = '700 37px "Space Grotesk", Arial, sans-serif';
    ctx.fillText(snapshot.species ? snapshot.species.name : 'No specimen assigned', WIDTH / 2, 925);
    ctx.fillStyle = '#57554e'; ctx.font = '700 24px "Space Grotesk", Arial, sans-serif';
    ctx.fillText('PERFORMANCE REVIEW', WIDTH / 2, 985);
    ctx.fillStyle = '#171714'; ctx.font = '700 48px "Space Grotesk", Arial, sans-serif';
    wrapped(ctx, snapshot.rank, WIDTH / 2, 1043, 900, 54);
    ctx.font = '500 27px "DM Sans", Arial, sans-serif';
    ctx.fillText('Can you beat ' + snapshot.score + '? innermons.com', WIDTH / 2, 1096);
    ctx.fillStyle = '#171714'; ctx.fillRect(70, 1123, 940, 104);
    ctx.fillStyle = '#f4f1e8'; ctx.textAlign = 'left'; ctx.font = '700 26px "Space Grotesk", Arial, sans-serif';
    ctx.fillText('FINAL SCORE', 104, 1162);
    ctx.font = '700 45px "Space Grotesk", Arial, sans-serif'; ctx.fillText(String(snapshot.score), 104, 1206);
    ctx.textAlign = 'right'; ctx.font = '700 31px "Space Grotesk", Arial, sans-serif';
    ctx.fillText('LEVEL ' + snapshot.level + ' / 4', 978, 1168);
    ctx.font = '400 26px "DM Sans", Arial, sans-serif';
    ctx.fillText(snapshot.hits + (snapshot.hits === 1 ? ' target contained' : ' targets contained'), 978, 1207);
    ctx.fillStyle = '#171714'; ctx.textAlign = 'left'; ctx.font = '700 27px "Space Grotesk", Arial, sans-serif';
    ctx.fillText('innermons.com', 70, 1285);
    ctx.textAlign = 'right'; ctx.font = '500 27px "DM Sans", Arial, sans-serif'; ctx.fillText('Stay Unbothered.', 1010, 1285);
    ctx.fillStyle = '#fff'; ctx.fillRect(70, 1320, 940, 400);
    drawPlayQR(ctx, developmentPreview);
    ctx.fillStyle = '#171714'; ctx.textAlign = 'left'; ctx.font = '700 42px "Space Grotesk", Arial, sans-serif';
    ctx.fillText('SCAN TO PLAY', 482, 1420);
    ctx.font = '700 29px "Space Grotesk", Arial, sans-serif'; ctx.fillText('INNERMON / OFFICE BREAK', 482, 1470);
    ctx.font = '400 29px "DM Sans", Arial, sans-serif';
    wrapped(ctx, 'Open the game. Set your own score.', 482, 1520, 480, 40);
    ctx.font = '500 27px "DM Sans", Arial, sans-serif'; ctx.fillText('innermons.com', 482, 1615);
    if (developmentPreview) {
      ctx.font = '400 22px "DM Sans", Arial, sans-serif';
      wrapped(ctx, 'Development preview. Store access may require a password.', 482, 1652, 480, 30);
    }
    return canvas;
  }
  class ResultImage {
    constructor(root) {
      this.root = root;
      this.preview = root.querySelector('[data-game-result-image]');
      this.panel = root.querySelector('[data-game-result-image-panel]');
      this.saveButton = root.querySelector('[data-game-action="save-image"]');
      this.shareButton = root.querySelector('[data-game-action="share-image"]');
      this.status = root.querySelector('[data-game-image-status]');
      this.ticket = 0; this.url = null; this.blob = null; this.controller = null;
      try { this.assets = JSON.parse(root.querySelector('[data-game-result-assets]').textContent); } catch (_) { this.assets = {}; }
    }
    clear() {
      this.ticket += 1;
      if (this.controller) this.controller.abort();
      this.controller = null; this.blob = null;
      if (this.url) URL.revokeObjectURL(this.url);
      this.url = null;
      if (this.preview) this.preview.removeAttribute('src');
      if (this.panel) this.panel.hidden = true;
      if (this.saveButton) { this.saveButton.hidden = true; this.saveButton.disabled = true; }
      if (this.shareButton) { this.shareButton.hidden = true; this.shareButton.disabled = true; }
      if (this.status) this.status.textContent = '';
    }
    async prepare(snapshot) {
      this.clear();
      const ticket = this.ticket;
      this.controller = new AbortController();
      const signal = this.controller.signal;
      if (this.status) this.status.textContent = 'Preparing your result image. Text sharing is already available.';
      try {
        let specimenSrc;
        if (snapshot.species) {
          specimenSrc = this.assets.species && this.assets.species[snapshot.species.key];
          if (!specimenSrc) throw new Error('Approved result artwork unavailable');
        }
        const artwork = Promise.all([loadImage(this.assets.logo, signal), ...(specimenSrc ? [loadImage(specimenSrc, signal)] : [])]);
        // Font failures are harmless: use the same readable system fallback.
        const fonts = document.fonts && document.fonts.load ? bounded(Promise.all([document.fonts.load('700 48px "Space Grotesk"'), document.fonts.load('400 30px "DM Sans"')]), 1200, 'Result font timeout').catch(() => {}) : Promise.resolve();
        const [[logo, specimen]] = await Promise.all([artwork, fonts]);
        if (ticket !== this.ticket || signal.aborted) return;
        const canvas = draw(snapshot, logo, specimen, this.assets.developmentPreview === true);
        const blob = await bounded(new Promise((resolve, reject) => canvas.toBlob((value) => value ? resolve(value) : reject(new Error('Result image could not be encoded')), 'image/png')), TIMEOUT_MS, 'Result encoding timeout');
        if (ticket !== this.ticket || signal.aborted) return;
        this.blob = blob;
        this.url = URL.createObjectURL(blob);
        if (this.preview) { this.preview.src = this.url; this.preview.alt = 'Innermon Office Break result: ' + snapshot.rank + ', score ' + snapshot.score + ', Level ' + snapshot.level + '. Includes a QR code to play Office Break.'; }
        if (this.panel) this.panel.hidden = false;
        if (this.saveButton) { this.saveButton.hidden = false; this.saveButton.disabled = false; }
        const canShareImage = !!this.shareableFile();
        if (this.shareButton) { this.shareButton.hidden = !canShareImage; this.shareButton.disabled = !canShareImage; }
        if (this.status) this.status.textContent = 'Result image ready with a scan-to-play QR code. Share it where supported, or save the PNG.';
      } catch (_) {
        if (ticket === this.ticket && !signal.aborted && this.status) this.status.textContent = 'The result image could not be prepared. You can still share or copy the text result.';
      } finally {
        if (ticket === this.ticket) { this.controller.abort(); this.controller = null; }
      }
    }
    file() {
      if (!this.blob || typeof File !== 'function') return null;
      return new File([this.blob], 'innermon-office-break-result.png', { type: 'image/png' });
    }
    shareableFile() {
      try {
        const file = this.file();
        return file && typeof navigator.share === 'function' && typeof navigator.canShare === 'function' && navigator.canShare({ files: [file] }) ? file : null;
      } catch (_) { return null; }
    }
    save() {
      if (!this.url) return false;
      const link = document.createElement('a');
      link.href = this.url; link.download = 'innermon-office-break-result.png';
      link.hidden = true; this.root.append(link); link.click(); link.remove();
      if (this.status) this.status.textContent = 'PNG download requested. Check your browser downloads.';
      return true;
    }
  }
  window.InnermonOfficeResultImage = ResultImage;
})();
